import React from 'react';
import { Button } from 'react-bootstrap';
import '../common/MobileCard.css';
import './MobileProductHub.css';

/*
 * Vue "terrain" de la fiche produit sur smartphone (< 768px).
 * Ne contient aucune logique métier : chaque action ouvre la section
 * correspondante de la version complète (formulaire, FTP, bilan...).
 */

const STATE_COLORS = {
  '#00FF00': 'green', green: 'green',
  orange: 'orange',
  red: 'red',
  '#0000FF': 'blue', blue: 'blue',
  black: 'black'
};

const CSS_COLORS = { green: '#3fae49', orange: '#f0ad4e', red: '#d9534f', blue: '#2a6fdb', black: '#333', grey: '#999' };

const ActionTile = ({ icon, label, onClick, bsStyle, disabled }) => (
  <button type="button" className={'mobile-hub-tile mobile-hub-tile-' + (bsStyle || 'default')} onClick={onClick} disabled={disabled}>
    <i className={'fa ' + icon} />
    <span>{label}</span>
  </button>
);

const MobileProductHub = ({
  t, product, typeLabel, stateSummary, warnings,
  sections, formSectionKey, ftpSectionKey, testLiftAvailable,
  onOpenSection, onSupervision, onHelp, onFullView
}) => {
  const color = STATE_COLORS[stateSummary && stateSummary.color] || 'grey';
  const address = [product.localisation_adresse, product.localisation_CP, product.localisation_ville].filter(Boolean).join(' ');
  const mapsUrl = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(address);
  const onOff = (v) => v ? t('mobileProduct.enabled') : t('mobileProduct.disabled');

  return (
    <div className="mobile-hub">

      <div className={'mobile-hub-summary mobile-card-' + color}>
        {typeLabel && <div className="mobile-hub-type">{typeLabel}</div>}
        <div className="mobile-hub-title">{product.identification_NUM_ASC || t('main.non_renseigne')}</div>

        <div className="mobile-hub-state">
          <i className="fa fa-circle" style={{ color: CSS_COLORS[color] }} />&nbsp;
          {(stateSummary && stateSummary.label) || t('mobileProduct.state_unknown')}
        </div>
        {stateSummary && stateSummary.error &&
          <div className="mobile-hub-error"><i className="fa fa-warning" /> {stateSummary.error}</div>
        }

        {address &&
          <a className="mobile-hub-address" href={mapsUrl} target="_blank" rel="noopener noreferrer">
            <i className="fa fa-map-marker" />
            <span>{address}</span>
            <span className="mobile-hub-directions">{t('mobileProduct.directions')} <i className="fa fa-external-link" /></span>
          </a>
        }

        <div className="mobile-hub-grid">
          <div><span>{t('main.identity')}</span>{product.identification_ID || '—'}</div>
          <div><span>GSM</span>{product.identification_GSM || '—'}</div>
          <div><span>{t('mobileProduct.module')}</span>{product.identification_NUM_MOD || '—'}</div>
          <div><span>{t('main.supervision')}</span>{onOff(product.etat_supervision)}</div>
          <div><span>{t('mobileProduct.telesurveillance')}</span>{onOff(product.etat_telesurveillance)}</div>
        </div>
      </div>

      {warnings}

      <div className="mobile-hub-section-title">{t('mobileProduct.quick_actions')}</div>
      <div className="mobile-hub-tiles">
        {formSectionKey != null &&
          <ActionTile icon="fa-pencil" bsStyle="primary" label={t('main.edit_sheet')} onClick={() => onOpenSection(formSectionKey)} />
        }
        {ftpSectionKey != null &&
          <ActionTile icon="fa-exchange" bsStyle="primary" label="FTP"
            disabled={sections.some(s => s.key === ftpSectionKey && s.disabled)}
            onClick={() => onOpenSection(ftpSectionKey)} />
        }
        <ActionTile icon="fa-eye" label={t('main.supervision')} onClick={onSupervision} />
        <ActionTile icon="fa-line-chart" bsStyle="warning" label={t('main.bilan')} onClick={() => onOpenSection(2000)} />
        {testLiftAvailable &&
          <ActionTile icon="fa-arrows-v" bsStyle="success" label={t('productForm.test_lift')} onClick={() => onOpenSection(2001)} />
        }
        <ActionTile icon="fa-question-circle" label={t('main.help')} onClick={onHelp} />
      </div>

      <div className="mobile-hub-section-title">{t('mobileProduct.all_sections')}</div>
      <div className="list-group mobile-hub-sections">
        {sections.map((s) =>
          <button type="button" key={s.key} className="list-group-item" disabled={s.disabled} onClick={() => onOpenSection(s.key)}>
            <span className="mobile-hub-section-label">{s.title}</span>
            <i className="fa fa-chevron-right" />
          </button>
        )}
      </div>

      <Button block onClick={onFullView} className="mobile-hub-full-btn">
        <i className="fa fa-desktop" />&nbsp; {t('mobileProduct.full_view')}
      </Button>
    </div>
  );
};

export default MobileProductHub;
